import { useParams } from 'react-router-dom';

const useGetParcelParams = () => {
  const params = useParams();
  const parcelCode = params?.parcelCode ?? '';
  const parcelNumber = parcelCode.split('*')[0];
  const postcodeOrOrderId = localStorage.getItem(`tracking/${parcelCode}`);

  return { parcelCode, parcelNumber, postcodeOrOrderId };
};

export default useGetParcelParams;
